import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import * as yup from 'yup'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import Toast from 'react-native-toast-message'
import Card from '../../shared/card/Card'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import CustomButton from '../../shared/button/Button'


const NyInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postnyonline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()



    const intialValues = {
        martialstatus: '',
        is_nyc_resident: '',
        is_yonkers_resident: '',
        totalfornyandyonkers: '',
        toalAllowancesforNewyork: '',
        nystateamount: '',
        nycityamount: '',
        yonkersamount: '',

    }
    const nyschema = () => {
        const baseSchema = {
            martialstatus: yup
                .string()
                .required('Martial Status is a required field'),
            is_nyc_resident: yup.string().required('Are you a resident of NewYorkCity is a required field'),
            is_yonkers_resident: yup.string().required('Are you a resident of Yonkers is a required field'),
            totalfornyandyonkers: yup.string().required('Total number of allowances you are claiming for New York State and Yonkers is a required field'),
            toalAllowancesforNewyork: yup.string().nullable(),
            nystateamount: yup.string().nullable(),
            nycityamount: yup.string().nullable(),
            yonkersamount: yup.string().nullable(),

        }
        return yup.object(baseSchema)
    }
    const schema = nyschema()
    const options1 = [
        {
            key: 1,
            value: 'Single or Head of household'
        },
        { key: 2, value: 'Married' },
        { key: 3, value: 'Married, but withhold at higher single rate' },

    ]

    const options2 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'NY Withholding Taxation'}
                    />
                </View>
            </View>
            <View style={[globalStyles.containerOverlap]}>
                <Formik
                    initialValues={intialValues}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {

                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey:
                                initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode === 'online' ? true : false,
                            isNyResident: (values?.is_nyc_resident as any) == 1 ? 1 : 0,
                            isYkResident: (values?.is_yonkers_resident as any) == 1 ? 1 : 0,
                            maritalStatus: values?.martialstatus,
                            totalAllowancesForNy: values?.toalAllowancesforNewyork ? values?.toalAllowancesforNewyork : null,
                            totalForNyandYonkers: values?.totalfornyandyonkers,
                            nyStateAmount: values?.nystateamount ? values?.nystateamount : null,
                            nyCityAmount: values?.nycityamount ? values?.nycityamount : null,
                            ykAmount: values?.yonkersamount ? values?.yonkersamount : null
                        }

                        const response = await postnyonline(data)
                        if (response?.success) {
                            if (mode === 'upload') {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                            else {
                                navigation.navigate('NyInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values
                                })
                            }
                        }
                        else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial Status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: "hidden" }}>
                                        <SelectKeyValue
                                            title="Martial Status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.martialstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('martialstatus', option - 1)
                                            }}
                                            textColor="primary"
                                        />{props.touched.martialstatus && props.errors.martialstatus && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.martialstatus}
                                            </Text>
                                        )}

                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you a resident of New York City (this includes the Bronx, Brooklyn, Manhattan, Queens, and Staten Island)? *'}
                                        </Text>
                                    </View>

                                    <View style={{ width: '30%', overflow: "hidden" }}>
                                        <SelectKeyValue
                                            key={`nyc-${props.values.is_nyc_resident}`}
                                            title="Are you a resident of NewYorkCity (this includes the Bronx, Brooklyn, Manhattan, Queens, and Staten Island)"
                                            options={options2}
                                            selectedOption={props.values.is_nyc_resident === 0 ? 'No' : props.values.is_nyc_resident === 1 ? 'Yes' : ''}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('is_nyc_resident', option - 1)
                                                if (option - 1 === 0) {
                                                    props.setFieldValue('nycityamount', '')
                                                    props.setFieldValue('toalAllowancesforNewyork', '')
                                                } else if (option - 1 === 1) {
                                                    props.setFieldValue('is_yonkers_resident', 0)
                                                    props.setFieldValue('yonkersamount', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />

                                        {props.touched.is_nyc_resident && props.errors.is_nyc_resident && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.is_nyc_resident}
                                            </Text>
                                        )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you a resident of Yonkers? *'}
                                        </Text>
                                    </View>

                                    <View style={{ width: '30%', overflow: "hidden" }}>
                                        <SelectKeyValue
                                            key={`yonk-${props.values.is_yonkers_resident}`}
                                            title="Are you a resident of Yonkers"
                                            options={options2}
                                            selectedOption={props.values.is_yonkers_resident === 0 ? 'No' : props.values.is_yonkers_resident === 1 ? 'Yes' : ''}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('is_yonkers_resident', option - 1)
                                                if (option - 1 === 0) {
                                                    props.setFieldValue('yonkersamount', '')
                                                } else if (option - 1 === 1) {
                                                    props.setFieldValue('is_nyc_resident', 0)
                                                    props.setFieldValue('nycityamount', '')
                                                    props.setFieldValue('toalAllowancesforNewyork', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />

                                        {props.touched.is_yonkers_resident && props.errors.is_yonkers_resident && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.is_yonkers_resident}
                                            </Text>
                                        )}
                                    </View>
                                </View>




                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Total number of allowances you are claiming for New York State and Yonkers, if applicable (from line 19, if using worksheet) *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: "hidden" }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.totalfornyandyonkers}
                                            keyboardType='numeric'
                                            onChangeText={(text) => {

                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('totalfornyandyonkers')(text)
                                                }
                                            }} />


                                        {props.touched.totalfornyandyonkers && props.errors.totalfornyandyonkers && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.totalfornyandyonkers}
                                            </Text>
                                        )}

                                    </View>
                                </View>


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'New York State amount'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: "hidden" }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.nystateamount}
                                            keyboardType='numeric'
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('nystateamount')(text)
                                                }
                                            }} />


                                        {props.touched.nystateamount && props.errors.nystateamount && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.nystateamount}
                                            </Text>
                                        )}

                                    </View>
                                </View>





                                {Number(props.values.is_nyc_resident) === 1 && (
                                    <>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'Total number of allowances for New York City '}
                                                </Text>
                                            </View>
                                            <View style={{ width: '30%', overflow: "hidden" }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.toalAllowancesforNewyork}
                                                    keyboardType='numeric'
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('toalAllowancesforNewyork')(text)
                                                        }
                                                    }} />


                                                {props.touched.toalAllowancesforNewyork && props.errors.toalAllowancesforNewyork && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.toalAllowancesforNewyork}
                                                    </Text>
                                                )}

                                            </View>
                                        </View>



                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {'New York City amount'}
                                                </Text>
                                            </View>
                                            <View style={{ width: '30%', overflow: "hidden" }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.nycityamount}
                                                    keyboardType='numeric'
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('nycityamount')(text)
                                                        }
                                                    }} />


                                                {props.touched.nycityamount && props.errors.nycityamount && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.nycityamount}
                                                    </Text>
                                                )}

                                            </View>
                                        </View>
                                    </>)}


                                {Number(props.values.is_yonkers_resident) === 1 && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '65%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Yonkers amount'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: "hidden" }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.yonkersamount}
                                                keyboardType='numeric'
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('yonkersamount')(text)
                                                    }
                                                }} />


                                            {props.touched.yonkersamount && props.errors.yonkersamount && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.yonkersamount}
                                                </Text>
                                            )}

                                        </View>
                                    </View>
                                )}

                                {loading ? (<ActivityIndicator />) : (<View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default NyInformationForm
